import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import { Modal } from './Modal';
import { useAuth0 } from '../../context/auth0';
import ModalDrawer from './ModalDrawer';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { BREAKPOINTS } from '../../../constants';
import Button, { ButtonSizes, ButtonStyles } from '../Button/Button';
import Typography, { TypographyVariants, TypographyWeights } from '../../ui-components/Typography/Typography';

const ModalSessionExpired = (props) => {
  const { loginWithRedirect } = useAuth0();
  const isDeviceSmallerThanTablet = !useMatchesMinWidth(BREAKPOINTS.TABLET);

  const modal = (
    <ModalDrawer
      isOpen={props.isOpen}
      modalCustomWidth={400}
      setIsOpen={() => null}
      isDeviceSmallerThanTablet={isDeviceSmallerThanTablet}
      title={app_main_wpml.login_to_continue}
      content={
        <div className='pt-m pl-m pr-m'>
          <Typography variant={TypographyVariants.p4}>
            {app_main_wpml.login_to_continue_alert}
          </Typography>
        </div>
      }
      footer={
        <div className={`d-flex justify-center pb-m pl-m pr-m ${isDeviceSmallerThanTablet ? 'flex-column gap-xs' : 'pt-m gap-m'}`}>
          <Button
            size={ButtonSizes.s}
            style={ButtonStyles.empty}
            label={<Typography variant={TypographyVariants.p3}>
              {app_main_wpml.back_to_home}
            </Typography>
            }
            redirect={'/'}
          />
          <Button
            size={ButtonSizes.s}
            style={ButtonStyles.empty}
            label={<Typography variant={TypographyVariants.p3} weight={TypographyWeights.bold}>
              {app_main_wpml.login}
            </Typography>
            }
            onClick={loginWithRedirect}
          />
        </div>
      }
    />);

  return modal;
};

ModalSessionExpired.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export { ModalSessionExpired };
